import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import { Option } from "../../generalTypes";
import "./FilterMultiSelect.scss";

interface FilterMultiSelectProps {
  label: string;
  options: Array<Option>;
  value: string;
  onChange: Function;
}

const isChecked = (optionValue: string, concatenatedValue: string) => {
  if (!concatenatedValue) return false;
  return concatenatedValue.split(',').includes(optionValue);
};

export default function FilterMultiSelect(props: FilterMultiSelectProps) {
  const { t } = useTranslation();

  const handleChange = (event: any, optionValue: string) => {
    const checked = event.target.checked;
    let values = props.value ? props.value.split(',').filter((v) => v !== "") : [];

    if (checked) {
      if (!values.includes(optionValue)) {
        values.push(optionValue);
      }
    } else {
      values = values.filter((v) => v !== optionValue);
    }

    props.onChange(values.join(','));
  };

  return (
    <Form.Group className="filter-multi-select-component pb-3">
      <div className="font-weight-600 mb-2 multi-select-label">
        {t(props.label)}
      </div>
      {props.options.map((option, i) => (
        <Form.Check
          key={i}
          className="text-gray-36 ms-1"
          type="checkbox"
          id={option.name}
          label={option.translateLabel ? t(option.label) : option.label}
          name={option.name}
          checked={isChecked(option.value, props.value)}
          onChange={(event) => {
            handleChange(event, option.value);
          }}
        />
      ))}
    </Form.Group>
  );
}
